import { staticSelector } from 'ducks/static'
import React, { FC } from 'react'
import { useSelector } from 'react-redux'
import {
  Container,
  Content,
  Title,
  CardDesign,
  Left,
  LeftIconContainer,
  Icon,
  TextContainer,
  Info,
  Vector,
  Right,
  RightIconContainer,
  InfoGrey,
  InfoGreen,
} from '../styledCard'
import vector from 'assets/Vector6.png'
import iconFuel from '../../../../assets/icon_fuel.png'
import { Metric } from '../../MetricsPage/types'

interface Props {
  data: Metric
}

export const Card5: FC<Props> = ({ data }) => {
  const state = useSelector(staticSelector)

  const { title, iconLeft, iconRight, textLeft, textRight } = state.content?.nationalMetric.subTabRender[3]

  return (
    <Container>
      <Content>
        {/* {title ? <Title>{title}</Title> : null} */}
        <CardDesign>
          <Left>
            <LeftIconContainer leftColor="#FF8F28">{iconFuel ? <Icon src={iconFuel} /> : null}</LeftIconContainer>
            <TextContainer>
              <>
                <Info>
                  <InfoGrey leftColor="#FF8F28">{data.fuel} gallons of fuel</InfoGrey>
                  Total $ savings of <InfoGrey leftColor="#FF8F28">${data.fuel_money}.</InfoGrey>
                </Info>
              </>
            </TextContainer>
          </Left>
          <Vector src={vector} />
          <Right>
            <RightIconContainer rightColor="#54AE2A">{iconFuel ? <Icon src={iconFuel} /> : null}</RightIconContainer>
            <TextContainer>
              <Info>
                That’s the equivalent of <InfoGreen>removing {data.fuel_visual} cars</InfoGreen> off the road
              </Info>
            </TextContainer>
          </Right>
        </CardDesign>
      </Content>
    </Container>
  )
}
